import { backendRequestAndNotification } from '../api'
import { useState } from 'react'

  
const AgeConfirmation = ({user, setShow}) => {
    const [date, setDate] = useState('')


    return (
        <>
            <div className='rewards-modal' onClick={(e) => { setShow(false) }}>
                <div className='rewards-container' onClick={(e) => e.stopPropagation()}>
                    <p className='close' onClick={(e) => { setShow(false) }}>x</p>

                    <p className='title gold'>Age Confirmation</p>

                    <p style={{marginTop: '8px'}}>What is your birth date?</p>
                    <div className='settings-section'>
                        <input value={date} onChange={(e) => setDate(e.target.value)} type='date'/>
                        <button onClick={() => {
                            backendRequestAndNotification('/user/confirm-age', 'POST', {date}) && setShow(false)
                        }}>Confirm</button>
                    </div>
                </div>
            </div>

            <style jsx>
                {`
                    .rewards-modal {
                        position: fixed;
                        height: 100%;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: rgba(0,0,0,0.3);
                        z-index: 1001;
                        top: 0;
                        left: 0;
                    }

                    .settings-section {
                        display: flex;
                        flex: 1;
                        height: 75px;
                        background-color: #141A31;
                        border-radius: 12px;
                        padding: 15px;
                        gap: 15px;
                    }
    
                    .settings-section input {
                        border: unset;
                        outline: unset;
                        width: 100%;
                        color: white;
                        background-color: #21284C;
                        padding: 0px 10px;
                        border-radius: 6px;
                        height: 45px;
                    }
    
                    .settings-section button {
                        border: unset;
                        outline: unset;
                        width: 150px;
                        color: white;
                        background-color: #4DAEFF;
                        border-radius: 6px;
                        cursor: pointer;
                    }

                    .title {
                        font-size: 16px;
                        font-weight: 500;
                    }

                    .gold {
                        color: #F1C475;
                    }

                    .green {
                        color: #63D68C;
                    }

                    .rewards-container {
                        position: relative;
                        height: fit-content;
                        width: 600px;
                        background: #21294D;
                        border-radius: 8px;

                        position: relative;

                        display: flex;
                        flex-direction: column;

                        padding: 24px;
                        box-sizing: border-box;
                        gap: 12px;

                        overflow: hidden;
                    }

                    .close {
                        font-weight: 700;
                        font-size: 12px;
                        position: absolute;
                        top: 8px;
                        right: 8px;
                        cursor: pointer;
                    }

                    .bar-header, .header {
                        display: flex;
                        justify-content: space-between;

                        font-weight: 600;
                        font-size: 14px;

                        width: 100%;
                    }

                    .bar-container {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        gap: 4px;
                    }

                    .bar {
                        width: 100%;
                        height: 5px;
                        background-color: #171D39;
                        border-radius: 2525px;
                        overflow: hidden;
                    }

                    .milestones {
                        display: flex;
                        justify-content: space-between;

                        font-weight: 600;
                        font-size: 14px;
                    }

                    .daily .header p {
                        background-color: #4D3A4B;
                        border-radius: 4px;
                        padding: 0px 6px;
                    }

                    .promocodes .header p {
                        background-color: #255558;
                        border-radius: 4px;
                        padding: 0px 6px;
                    }

                    .daily, .promocodes {
                        border-radius: 8px;
                        box-shadow: 0 3px 10px rgb(0,0,0,0.2);
                        width: 100%;
                        height: fit-content;
                        min-height: 100px;
                        padding: 16px;
                        box-sizing: border-box;

                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        gap: 16px;
                    }
                    
                    .input-container {
                        width: 100%;
                        height: 35px;

                        display: flex;

                        gap: 8px;
                    }

                    .promocode {
                        width: 100%;
                        height: 100%;
                        background-color: #1D3446;
                    }

                    .daily {
                        background-color: #2A335B;
                    }

                    .promocodes {
                        background-color: #262E58;
                    }

                    .promocode {
                        outline: unset;
                        border: unset;
                        border-radius: 4px;
                        padding: 0px 8px;
                        color: white;
                    }

                    .promocodes .claim:hover {
                        background-color: #255459;
                    }

                    .daily .claim:hover {
                        background-color: #5d4b5b;
                    }

                    .claim:active {
                        transform: scale(0.95);
                    }

                    .claim {
                        border: unset;
                        outline: unset;
                        cursor: pointer;
                        border-radius: 4px;
                        font-weight: 600;
                    }

                    .daily .claim {
                        width: 100px;
                        height: 30px;
                        background-color: #4D3A4B;
                        transition: all 0.3s;
                        transition: transform 0.05s;
                    }

                    .promocodes .claim {
                        background-color: #1D3446;
                        width: 150px;
                        transition: all 0.3s;
                        transition: transform 0.05s;
                    }

                    p {
                        margin: unset;
                    }
                `}
            </style>
        </>
    )
}

export default AgeConfirmation